//====================================================
//  Function: Copy text
//====================================================
function componentCopyText() {
  if ($('.js-copy-text').length) {
    $('.js-copy-text').click(function () {
      // var copyText = $(this)
      var copyTextValue = $('#main-copy').text()
      navigator.clipboard.writeText(copyTextValue)
      openTooltip()
    })

    $('.js-copy-text-value').click(function () {
      // var copyText = $(this)
      var copyTextValue = $(this)
        .closest('.label__value-block')
        .find('.js-label-value')
        .text()
      navigator.clipboard.writeText(copyTextValue)
      openTooltip()
    })

    $('.js-copy-text-css').click(function () {
      // var copyText = $(this)
      var copyTextValue = $('#main-copy-css').text()
      navigator.clipboard.writeText(copyTextValue)
      openTooltip()
    })
  }
}

var myTimeout
function openTooltip() {
  clearTimeout(myTimeout)
  $('.js-open-tooltip').addClass('is-active')

  myTimeout = setTimeout(function () {
    $('.js-open-tooltip').removeClass('is-active')
  }, 2000)
}
